import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from '@edx/frontend-platform/i18n';

import DynamicStringList from '../../generic/dynamic-string-list';
import SectionSubHeader from '../../generic/section-sub-header';
import messages from './messages';

const LearningOutcomesSection = ({ learningInfo, onChange }) => {
  const intl = useIntl();

  return (
    <section className="section-container learning-outcomes-section">
      <SectionSubHeader
        title={intl.formatMessage(messages.outcomesTitle)}
        description={intl.formatMessage(messages.outcomesDescription)}
      />
      <DynamicStringList
        items={learningInfo}
        fieldKey="learningInfo"
        label={intl.formatMessage(messages.outcomesLabelIncrement)}
        addLabel={intl.formatMessage(messages.outcomesAdd)}
        deleteLabel={intl.formatMessage(messages.outcomesDelete)}
        placeholder={intl.formatMessage(messages.outcomesInputPlaceholder)}
        onChange={onChange}
      />
    </section>
  );
};

LearningOutcomesSection.defaultProps = {
  learningInfo: [],
};

LearningOutcomesSection.propTypes = {
  learningInfo: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
};

export default LearningOutcomesSection;
